export var ViewerEventType;
(function (ViewerEventType) {
    ViewerEventType["ViewportChange"] = "VIEWPORT_CHANGE";
    ViewerEventType["PreviewRendered"] = "PREVIEW_RENDERED";
    ViewerEventType["ViewRendered"] = "VIEW_RENDERED";
    ViewerEventType["FocusChange"] = "FOCUS_CHANGE";
    ViewerEventType["RenderedViewFocus"] = "RENDERED_VIEW_FOCUS";
    ViewerEventType["RenderedPreviewFocus"] = "RENDERED_PREVIEW_FOCUS";
    ViewerEventType["PublicFocusChange"] = "PUBLIC_FOCUS_CHANGE";
    ViewerEventType["PublicRenderedViewFocus"] = "PUBLIC_RENDERED_VIEW_FOCUS";
    ViewerEventType["PublicRenderedPreviewFocus"] = "PUBLIC_RENDERED_PREVIEW_FOCUS";
    ViewerEventType["SelectView"] = "SELECT_VIEW";
    ViewerEventType["DeselectView"] = "DESELECT_VIEW";
    ViewerEventType["UrlAssetClicked"] = "URL_ASSET_CLICKED";
    ViewerEventType["StartLoading3dModel"] = "START_LOADING_3D_MODEL";
    ViewerEventType["StartViewing3dModel"] = "START_VIEWING_3D_MODEL";
    ViewerEventType["StopViewing3dModel"] = "STOP_VIEWING_3D_MODEL";
    ViewerEventType["OpenInOfficeOnline"] = "OPEN_IN_OFFICE_ONLINE";
    ViewerEventType["PlaybackStart"] = "PLAYBACK_START";
    ViewerEventType["PlaybackPause"] = "PLAYBACK_PAUSE";
    ViewerEventType["PlaybackEnd"] = "PLAYBACK_END";
    ViewerEventType["WebappOpen"] = "WEBAPP_OPEN";
    ViewerEventType["WebappClose"] = "WEBAPP_CLOSE";
    ViewerEventType["DownloadAsset"] = "DOWNLOAD_ASSET";
    ViewerEventType["SetView"] = "SET_VIEW";
    ViewerEventType["NavigateToPage"] = "NAVIGATE_TO_PAGE";
    ViewerEventType["Update"] = "UPDATE";
    ViewerEventType["FullscreenChange"] = "FULLSCREEN_CHANGE";
    ViewerEventType["ToggleFullscreen"] = "TOGGLE_FULLSCREEN";
    ViewerEventType["AddViews"] = "ADD_VIEWS";
    ViewerEventType["Resize"] = "RESIZE";
    ViewerEventType["Swipe"] = "SWIPE";
    ViewerEventType["SwitchLayout"] = "SWITCH_LAYOUT";
    ViewerEventType["ThumbnailsOpenedChange"] = "THUMBNAILS_OPENED_CHANGE";
    ViewerEventType["ThumbnailsOpenedChanged"] = "THUMBNAILS_OPENED_CHANGED";
    ViewerEventType["ObservableDimensionsIframeDimensionsChanged"] = "OBSERVABLE_DIMENSIONS_IFRAME_DIMENSIONS_CHANGED";
    ViewerEventType["LayoutZoomChange"] = "LAYOUT_ZOOM_CHANGE";
    ViewerEventType["EnableNavigationOnlyWithinCurrentAssetViewerItem"] = "ENABLE_NAVIGATION_ONLY_WITHIN_CURRENT_ASSET_VIEWER_ITEM";
    ViewerEventType["DisableNavigationOnlyWithinCurrentAssetViewerItem"] = "DISABLE_NAVIGATION_ONLY_WITHIN_CURRENT_ASSET_VIEWER_ITEM";
    ViewerEventType["EnableAnnotations"] = "ENABLE_ANNOTATIONS";
    ViewerEventType["DisableAnnotations"] = "DISABLE_ANNOTATIONS";
})(ViewerEventType || (ViewerEventType = {}));
// VIEWPORT_CHANGE
export class ViewerViewportChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.ViewportChange;
    }
}
// PREVIEW_RENDERED
export class ViewerPreviewRenderedEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.PreviewRendered;
    }
}
// VIEW_RENDERED
export class ViewerViewRenderedEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.ViewRendered;
    }
}
// FOCUS_CHANGE
export class ViewerFocusChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.FocusChange;
    }
}
// RENDERED_VIEW_FOCUS
export class ViewerRenderedViewFocusEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.RenderedViewFocus;
    }
}
// RENDERED_PREVIEW_FOCUS
export class ViewerRenderedPreviewFocusEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.RenderedPreviewFocus;
    }
}
// PUBLIC_FOCUS_CHANGE
export class ViewerPublicFocusChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.PublicFocusChange;
    }
}
// PUBLIC_RENDERED_VIEW_FOCUS
export class ViewerPublicRenderedViewFocusEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.PublicRenderedViewFocus;
    }
}
// PUBLIC_RENDERED_PREVIEW_FOCUS
export class ViewerPublicRenderedPreviewFocusEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.PublicRenderedPreviewFocus;
    }
}
// NAVIGATE_TO_PAGE
export class ViewerNavigateToPageEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.NavigateToPage;
    }
}
// SELECT_VIEW
export class ViewerSelectViewEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.SelectView;
    }
}
// DESELECT_VIEW
export class ViewerDeselectViewEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.DeselectView;
    }
}
// SET_VIEW
export class ViewerSetViewEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.SetView;
    }
}
// URL_ASSET_CLICKED
export class ViewerUrlAssetClickedEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.UrlAssetClicked;
    }
}
// START_LOADING_3D_MODEL
export class ViewerStartLoading3dModelEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.StartLoading3dModel;
    }
}
// START_VIEWING_3D_MODEL
export class ViewerStartViewing3dModelEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.StartViewing3dModel;
    }
}
// STOP_VIEWING_3D_MODEL
export class ViewerStopViewing3dModelEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.StopViewing3dModel;
    }
}
// PLAYBACK_START
export class ViewerPlaybackStartEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.PlaybackStart;
    }
}
// PLAYBACK_PAUSE
export class ViewerPlaybackPauseEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.PlaybackPause;
    }
}
// PLAYBACK_END
export class ViewerPlaybackEndEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.PlaybackEnd;
    }
}
// WEBAPP_OPEN
export class ViewerWebappOpenEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.WebappOpen;
    }
}
// WEBAPP_CLOSE
export class ViewerWebappCloseEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.WebappClose;
    }
}
// DOWNLOAD_ASSET
export class ViewerDownloadAssetEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.DownloadAsset;
    }
}
// OPEN_IN_OFFICE_ONLINE
export class ViewerOpenInOfficeOnlineEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.OpenInOfficeOnline;
    }
}
// UPDATE
export class ViewerUpdateEvent {
    constructor() {
        this.type = ViewerEventType.Update;
    }
}
// FULLSCREEN_CHANGE
export class ViewerFullscreenChangeEvent {
    constructor() {
        this.type = ViewerEventType.FullscreenChange;
    }
}
// TOGGLE_FULLSCREEN
export class ViewerToggleFullscreenEvent {
    constructor() {
        this.type = ViewerEventType.ToggleFullscreen;
    }
}
// ADD_VIEWS
export class ViewerAddViewsEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.AddViews;
    }
}
// RESIZE
export class ViewerResizeEvent {
    constructor() {
        this.type = ViewerEventType.Resize;
    }
}
// SWITCH VIEW MODE
export class ViewerSwitchLayoutEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.SwitchLayout;
    }
}
// THUMBNAILS_OPENED_CHANGE
export class ViewerThumbnailsOpenedChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.ThumbnailsOpenedChange;
    }
}
// THUMBNAILS_OPENED_CHANGED
export class ViewerThumbnailsOpenedChangedEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.ThumbnailsOpenedChanged;
    }
}
export class ViewerObservableDimensionsIframeDimensionsChangedEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = ViewerEventType.ObservableDimensionsIframeDimensionsChanged;
    }
}
// LAYOUT_ZOOM_CHANGE
export class ViewerLayoutZoomChangeEvent {
    constructor() {
        this.type = ViewerEventType.LayoutZoomChange;
    }
}
// ENABLE_NAVIGATION_ONLY_WITHIN_CURRENT_ASSET_VIEWER_ITEM
export class ViewerEnableNavigationWithinCurrentAssetViewerItemEvent {
    constructor() {
        this.type = ViewerEventType.EnableNavigationOnlyWithinCurrentAssetViewerItem;
    }
}
// DISABLE_NAVIGATION_ONLY_WITHIN_CURRENT_ASSET_VIEWER_ITEM
export class ViewerDisableNavigationWithinCurrentAssetViewerItemEvent {
    constructor() {
        this.type = ViewerEventType.DisableNavigationOnlyWithinCurrentAssetViewerItem;
    }
}
//# sourceMappingURL=ViewerEvents.type.js.map